import React from 'react';
import bemBlock, { bemFunction } from '@gik/core/utils/bemBlock';
import { IconSetType, IMenuItem, Menu } from '@gik/ui';
import SvgIcon from '../SvgIcon';

const blockName = 'menu-bar';

type MenuListItem = {
  title: string | React.ReactElement;
  menu: IMenuItem[];
  appendIcon?: IconSetType;
  prependIcon?: IconSetType;
};

export interface IMenuBarProps extends React.HTMLAttributes<HTMLElement> {
  menuList: MenuListItem[];
  className?: string;
}

export type IMenuBarElement = HTMLElement & {
  closeAll: () => void;
};

export default function MenuBar({ menuList, className, ...otherProps }: IMenuBarProps) {
  const bem = bemBlock(blockName);

  const [openItem, setOpenItem] = React.useState<number>(null);

  const closeAll = () => setOpenItem(null);

  const ref = React.useRef<HTMLElement>();

  React.useImperativeHandle(ref, () => ({
    closeAll,
    ...ref.current,
  }));

  return (
    <nav
      ref={ref}
      className={bem(
        null,
        [
          {
            open: openItem !== null,
          },
        ],
        className
      )}
      {...otherProps}
    >
      {menuList.map((menu, i) => (
        <MenuBarItem key={i} menu={menu} i={i} bem={bem} openItem={openItem} setOpenItem={setOpenItem} />
      ))}
    </nav>
  );
}

function MenuBarItem({
  menu,
  i,
  bem,
  openItem,
  setOpenItem,
}: {
  menu: MenuListItem;
  i: number;
  bem: bemFunction;
  openItem: number;
  setOpenItem: React.Dispatch<React.SetStateAction<number>>;
}) {
  const itemTitle = (
    <header className={bem('item-title')} onClick={() => setOpenItem(i)}>
      {menu.prependIcon && <SvgIcon className={bem('icon', [{ prepend: true }])} {...menu.prependIcon} />}

      <a href="#" className={bem('title')}>
        {menu.title}
      </a>

      {menu.appendIcon && <SvgIcon className={bem('icon', [{ append: true }])} {...menu.appendIcon} />}
    </header>
  );

  return (
    <Menu
      trigger={itemTitle}
      isOpen={openItem === i}
      onClose={() => setOpenItem(null)}
      onHover={() => setOpenItem(i)}
      className={bem('item-menu')}
      items={menu.menu}
    />
  );
}
